import { configureStore } from '@reduxjs/toolkit'
import { sessionSlice } from 'pages/session/store/slices'
import { type TypedUseSelectorHook, useSelector } from 'react-redux'
import { resumeSessionSlice } from 'pages/resume/slices'
import { settingsSlice } from 'redux/settingsSlice'
import { virtualApiUserTokenSlice } from 'pages/session/virtualApiUserTokenSlice'
import { userInfoSlice } from 'pages/login/store/slices'

const storeConfig = {
  reducer: {
    settings: settingsSlice.reducer,
    session: sessionSlice.reducer,
    resumeSession: resumeSessionSlice.reducer,
    apiToken: virtualApiUserTokenSlice.reducer,
    userInfo: userInfoSlice.reducer,
  },
  middleware: (getDefaultMiddleware: any) => getDefaultMiddleware(),
}

export const store = configureStore(storeConfig)

export type RootState = ReturnType<typeof store.getState>
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector

export const generateStoreWithInitialState = (
  initialState: Partial<RootState>
) => configureStore({ ...storeConfig, preloadedState: initialState })
